import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "banner w-full lg:h-18 h-60 relative" }
const _hoisted_3 = { class: "flex items-center flex-column w-full h-full" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-center w-full container" }
const _hoisted_6 = { class: "w-full h-48 flex items-center flex-col -mt-6 md:mb-16" }
const _hoisted_7 = { class: "md:w-3/4 w-full h-full flex items-center justify-evenly" }
const _hoisted_8 = { class: "w-full flex flex-col items-center justify-center md:px-0 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_divider_component = _resolveComponent("divider-component")!
  const _component_fa = _resolveComponent("fa")!
  const _component_service_card_component = _resolveComponent("service-card-component")!
  const _component_informational_text_component = _resolveComponent("informational-text-component")!
  const _component_service_box_component = _resolveComponent("service-box-component")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_divider_component, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Services")
                ])),
                _: 1,
                __: [0]
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_service_card_component, {
          title: 'WiFi',
          description: 'WiFi doorheen heel de zaak!'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa, { icon: ['fas', 'wifi'] })
          ]),
          _: 1
        }),
        _createVNode(_component_service_card_component, {
          title: 'Parking',
          description: ' Parking achter- en vooraan de zaak!'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa, { icon: ['fas', 'parking'] })
          ]),
          _: 1
        }),
        _createVNode(_component_service_card_component, {
          title: 'Cadeaubonnen',
          description: 'Cadeaubonnen kunnen hier gebruikt worden'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa, { icon: ['fas', 'gift'] })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_informational_text_component, { class: "md:mt-8 mt-6" }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Voor meer informatie omtrent WiFi en cadeaubonnen kan je dat altijd vragen aan de dames in de zaak! ")
        ])),
        _: 1,
        __: [1]
      }),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm italic my-12" }, null, -1))
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createVNode(_component_service_box_component, {
        "is-right": false,
        "image-name": 'Sandwhichmand.png'
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("h1", { class: "font-bold md:text-xl text-md mb-2" }, "Feestje?", -1),
          _createElementVNode("div", { class: "bg-orange-200 h-px w-8/12 my-1" }, null, -1),
          _createElementVNode("p", { class: "md:text-md text-sm flex flex-col mt-2" }, [
            _createTextVNode(" Heeft u een vergadering, een receptie of een feestje? "),
            _createElementVNode("span", null, " Wij zorgen met plezier voor een lekker broodje of zoete hap. ")
          ], -1)
        ])),
        _: 1,
        __: [3]
      }),
      _createVNode(_component_service_box_component, {
        "is-right": true,
        "image-name": 'Broodjesmand.png'
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("h1", { class: "font-bold md:text-xl text-md mb-2" }, "Talloze mogelijkheden", -1),
          _createElementVNode("div", { class: "bg-orange-200 h-px w-8/12 my-1" }, null, -1),
          _createElementVNode("p", { class: "md:text-md text-sm mt-2" }, " Keuze uit verschillende soorten beleg. Alles wordt mooi gepresenteerd in broodmanden of op plateaus. ", -1),
          _createElementVNode("div", { class: "flex flec-col mt-6 ml-4" }, [
            _createElementVNode("ul", { class: "md:text-md text-sm list-disc" }, [
              _createElementVNode("li", null, "Open belegde broodjes"),
              _createElementVNode("li", null, "Mini-sandwinos")
            ]),
            _createElementVNode("ul", { class: "md:text-md text-sm list-disc ml-8" }, [
              _createElementVNode("li", null, "Mini-koffiekoekjes"),
              _createElementVNode("li", null, "Mini-donutjes")
            ])
          ], -1)
        ])),
        _: 1,
        __: [4]
      }),
      _createVNode(_component_service_box_component, {
        "is-right": false,
        "image-name": 'gallery-image1.jpeg'
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("h1", { class: "font-bold md:text-xl text-md mb-2" }, "Meer informatie?", -1),
          _createElementVNode("div", { class: "bg-orange-200 h-px w-8/12 my-1" }, null, -1),
          _createElementVNode("p", { class: "md:text-md text-sm mt-2 flex flex-col" }, [
            _createTextVNode(" Wenst u meer informatie over onze feestmanden, stuur ons even een mailtje of kom gewoon even langs. "),
            _createElementVNode("span", null, "Wij maken graag met u een afspraak om de details te bespreken.")
          ], -1)
        ])),
        _: 1,
        __: [5]
      })
    ])
  ]))
}